import Player from '@vimeo/player';

export class VideosEditorial {
  constructor(config = {}) {
    this.config = {
      thirdPartyAcceptedClass: 'third-party-accepted',
      parent: '.editorial-content',
      videoPlaceholder: '.video-placeholder',
      videoTemplate: '.editorial-video-template',
      videoWrapper: '.video-wrapper',
      dataVimeoId: 'vimeo-id',
      allowMultiPlay: false,
      ...config,
    };

    this.onThirdPartyAccepted = this.onThirdPartyAccepted.bind(this);
    this.onPlay = this.onPlay.bind(this);
    this.setupEventListeners();
  }

  setupEventListeners() {
    const { thirdPartyAcceptedClass } = this.config;
    if (document.documentElement.classList.contains(thirdPartyAcceptedClass)) {
      this.onThirdPartyAccepted();
    } else {
      window.addEventListener('thirdparty.accepted', this.onThirdPartyAccepted);
    }
  }

  onThirdPartyAccepted() {
    const { parent, videoPlaceholder, videoTemplate, dataVimeoId } = this.config;

    document.querySelectorAll(`${parent} ${videoPlaceholder}`).forEach((placeholder) => {
      const tpl = placeholder.closest(parent).querySelector(videoTemplate);
      if (!tpl) return;

      const wrapperContainer = document.createElement('div');
      wrapperContainer.innerHTML = tpl.innerHTML.trim();
      const videoWrap = wrapperContainer.firstElementChild;
      if (!videoWrap) return;

      const videoEl = videoWrap.querySelector(`[data-${dataVimeoId}]`);
      if (!videoEl) return;

      tpl.insertAdjacentElement('afterend', videoWrap);
      tpl.remove();

      const player = new Player(videoEl);
      player.on('play', () => this.onPlay(player));

      placeholder.remove();
    });
  }

  onPlay(activePlayer) {
    const { parent, videoWrapper, dataVimeoId, allowMultiPlay } = this.config;
    document.querySelectorAll(`${parent} ${videoWrapper} [data-${dataVimeoId}]`).forEach((videoEl) => {
      const player = new Player(videoEl);
      if (!allowMultiPlay && player !== activePlayer) {
        player.getPaused().then((isPaused) => {
          if (!isPaused) {
            player.pause();
            player.setCurrentTime(0);
          }
        });
      }
    });
  }
}
